import Constants from "@/constants";
import React from "react";
import HeaderBar from "./HeaderBar";
import ClientApp from "./ClientApp";
import LiveApp from "./LiveApp/indext";
import { useCurTab } from "@/hooks";
import Bg from "@/components/Bg";
import GlobalTransition from "@/components/GlobalTransition";

interface IMobilePageProps {
  isLoading: boolean;
}
const MobilePage: React.FC<IMobilePageProps> = ({ isLoading }) => {
  const [curTab, setCurTab] = useCurTab();
  return (
    <>
      <GlobalTransition isLoading={isLoading} />
      {!isLoading && (
        <>
          <Bg isLive={curTab === Constants.ETabKey.LIVE_APP} />
          <div className="relative flex h-full w-full flex-col overflow-hidden pt-[40px]">
            <div className="px-[16px]">
              <HeaderBar tabList={Constants.TAB_LIST} curTab={curTab} setCurTab={setCurTab} />
            </div>
            {curTab === Constants.ETabKey.CLIENT_APP ? <ClientApp /> : <LiveApp />}
          </div>
        </>
      )}
    </>
  );
};

export default MobilePage;
